/**
 * SAT MASTER · Komplettes Foliendeck (37 Folien · 25 Module)
 * Alle Korrekturen aus dem Review-Prozess sind eingearbeitet.
 *
 * Schema:
 *   { num, type, title, subtitle, kicker, bullets, quote, side, footerBar,
 *     mantra, mantraSub, special }
 *
 * type: 'cover' | 'content' | 'comparison' | 'process' | 'pricing' |
 *       'funnel' | 'formula' | 'cases' | 'finale'
 */

export const slides = [
  /* 01 */ {
    num: 1, type: "cover",
    title: "SAT MASTER",
    subtitle: "Die Spielregeln des Lebens verstehen und anwenden",
    tagline: "TRANSFORMATION · BEWUSSTSEIN · BEZIEHUNG · BERUFUNG",
  },
  /* 02 — FIX: Wirkung 2× im Kreislauf → Ursache → Wirkung → Wiederholung → Verstärkung */
  {
    num: 2, type: "content",
    kicker: "WARUM MENSCHEN LEIDEN",
    title: "Solange wir die Spielregeln nicht kennen, wiederholen wir dieselben Erfahrungen.",
    bullets: [
      { h: "Konflikte in Beziehungen", t: "Wiederkehrende Muster, die schmerzen — aber nicht zufällig sind." },
      { h: "Selbstzweifel", t: "Die leise Stimme, die deine Größe seit Jahren klein hält." },
      { h: "Geldprobleme", t: "Das innere Skript, das Fülle systematisch verhindert." },
      { h: "Sinnkrisen", t: "Das Gefühl, dass Erfolg leer schmeckt, wenn er nicht deiner ist." },
      { h: "Wiederkehrende Herausforderungen", t: "Dasselbe Thema, neue Kulisse — bis du die Spielregel erkennst." },
    ],
    side: { title: "Der ungesehene Kreislauf", items: ["Ursache", "Wirkung", "Wiederholung", "Verstärkung"] },
  },
  /* 03 */
  {
    num: 3, type: "content",
    kicker: "MODUL 1 · GRUNDLAGEN",
    title: "Das Leben folgt Gesetzmäßigkeiten.",
    bullets: [
      { h: "Psychologie", t: "Verstehen, was in uns wirkt." },
      { h: "Systemik", t: "Erkennen der Zusammenhänge." },
      { h: "Human Design", t: "Deine Einzigartigkeit entschlüsseln." },
      { h: "Spiegelgesetze", t: "Die Welt als Spiegel verstehen." },
      { h: "Neurowissenschaft", t: "Das Gehirn verstehen, verändern, nutzen." },
      { h: "Bewusstseinsforschung", t: "Bewusstsein erweitern. Realität gestalten." },
    ],
  },
  /* 04 — FIX: erschafft → schafft (Konsistenz) */
  {
    num: 4, type: "content",
    kicker: "DAS SAT MODELL",
    title: "Die 8 Säulen der Transformation.",
    bullets: [
      { h: "01 · Gesundheit", t: "Dein Körper als Fundament." },
      { h: "02 · Beziehungen", t: "Die Spiegel deines Lebens." },
      { h: "03 · Familie", t: "Die Wurzel deiner Identität." },
      { h: "04 · Berufung", t: "Das, wofür du brennst." },
      { h: "05 · Finanzen", t: "Energie in materieller Form." },
      { h: "06 · Bewusstsein", t: "Die Tiefe deiner Wahrnehmung." },
      { h: "07 · Spiritualität", t: "Die Verbindung über dich hinaus." },
      { h: "08 · Lebensvision", t: "Der Kompass für jedes Jahrzehnt." },
    ],
    mantra: "Balance schafft Klarheit. Klarheit schafft Freiheit. Freiheit schafft Leben.",
  },
  /* 05 */
  {
    num: 5, type: "process",
    kicker: "DER UNSICHTBARE FADEN™",
    title: "Alles hängt zusammen.",
    bullets: [
      { h: "Wurzel", t: "Prägungen, Erfahrungen, Glaubenssätze, Konditionierungen." },
      { h: "Gedanken", t: "Bewertungen, Überzeugungen, innere Dialoge." },
      { h: "Gefühle", t: "Emotionen, Stimmungen, innere Zustände." },
      { h: "Handlungen", t: "Entscheidungen, Verhalten, Reaktionen." },
      { h: "Ergebnisse", t: "Erfahrungen, Realität, Lebensqualität." },
    ],
  },
  /* 06 */
  {
    num: 6, type: "cover",
    title: "Die Spielregeln des Lebens meistern.",
    subtitle: "6 Monate. 8 Lebensbereiche. Tiefe Transformation.",
    tagline: "VORHER → NACHHER",
  },
  /* 07 — FIX: Purpose → Berufung */
  {
    num: 7, type: "content",
    kicker: "DEIN KOMPASS",
    title: "Wenn du deine Richtung kennst, wird jeder Schritt dich deinem Ziel näher bringen.",
    bullets: [
      { h: "Klare Vision", t: "Entdecke deine Lebensvision und deine wahre Berufung." },
      { h: "Innere Ausrichtung", t: "Finde den ruhigen Punkt, von dem aus du entscheidest." },
      { h: "Entscheidungen meistern", t: "Lerne, bewusste Entscheidungen zu treffen und konsequent umzusetzen." },
      { h: "Dein Weg", t: "Folge nicht der Karte anderer — zeichne deine eigene." },
    ],
  },
  /* 08 — FIX: "dein Licht leuchtest" → "dein Licht leuchten lässt" */
  {
    num: 8, type: "content",
    kicker: "DEIN LEUCHTTURM",
    title: "Wenn du dein Licht leuchten lässt, gibst du anderen die Erlaubnis, dasselbe zu tun.",
    bullets: [
      { h: "Innere Stabilität", t: "Werde in dir selbst stabil, unabhängig von äußeren Umständen." },
      { h: "Klarheit ausstrahlen", t: "Was klar in dir ist, klärt sich in deinem Umfeld." },
      { h: "Vorbild sein", t: "Du veränderst die Welt, indem du dich veränderst." },
      { h: "Wert erschaffen", t: "Dein Sein ist dein größtes Geschenk." },
    ],
    side: {
      title: "Die 5 Prinzipien des Leuchtturms",
      items: ["Authentizität", "Konsistenz", "Verbindung", "Verantwortung", "Wachstum"],
    },
  },
  /* 09 */
  {
    num: 9, type: "process",
    kicker: "DEIN TRANSFORMATIONSPLAN",
    title: "8 Schritte zu deinem neuen Leben.",
    bullets: [
      { h: "01 · Bestandsaufnahme", t: "Wo stehst du gerade? Was erfüllt dich, was nicht?" },
      { h: "02 · Klare Vision", t: "Was soll in 12 Monaten Realität sein?" },
      { h: "03 · Ziele setzen", t: "Aus Vision werden konkrete, messbare Schritte." },
      { h: "04 · Plan erstellen", t: "Der Weg vom Heute zum Morgen." },
      { h: "05 · Umsetzen", t: "Vom Wissen ins Tun." },
      { h: "06 · Dranbleiben", t: "Konsistenz schlägt Motivation." },
      { h: "07 · Überprüfen & Anpassen", t: "Justiere bewusst — nicht aus Angst, sondern aus Klarheit." },
      { h: "08 · Feiern & Wachsen", t: "Was du würdigst, wächst." },
    ],
  },
  /* 10 — FIX: "in Einklang" → "voller Einklang" */
  {
    num: 10, type: "content",
    kicker: "DEINE WERTE",
    title: "Die Grundlage für ein erfülltes Leben.",
    bullets: [
      { h: "Integrität", t: "Das, was du im Inneren bist, im Außen leben." },
      { h: "Mitgefühl", t: "Begegne dir selbst und anderen mit einem offenen Herzen." },
      { h: "Mut", t: "Trotz Angst handeln — das ist Mut, nicht Furchtlosigkeit." },
      { h: "Wachstum", t: "Bleibe neugierig, lerne kontinuierlich, entwickle dich jeden Tag weiter." },
      { h: "Verantwortung", t: "Übernimm Verantwortung für dein Leben — kompromisslos." },
    ],
    mantra: "Lebe nach deinen Werten und du führst ein Leben voller Einklang, Erfüllung und Bedeutung.",
  },
  /* 11 — FIX: 5. Praxis hatte keine Beschriftung → "Mitgefühl" ergänzt */
  {
    num: 11, type: "content",
    kicker: "DEINE RESSOURCEN",
    title: "Nutze deine inneren und äußeren Ressourcen.",
    bullets: [
      { h: "Innere Stärken", t: "Vertraue auf das, was bereits in dir ist." },
      { h: "Unterstützung", t: "Niemand wächst allein — finde dein Umfeld." },
      { h: "Wissen & Lernen", t: "Bleibe lernend — das Leben ist die größte Schule." },
      { h: "Gesundheit", t: "Dein Körper ist das Fahrzeug deiner Vision." },
      { h: "Zeit & Fokus", t: "Wo deine Aufmerksamkeit ist, ist dein Leben." },
    ],
    side: {
      title: "Tägliche Praxis",
      items: [
        "Dankbarkeit — öffnet das Herz",
        "Achtsamkeit — sei im Hier und Jetzt",
        "Selbstreflexion — frag dich täglich",
        "Selbstliebe — beginne bei dir",
        "Mitgefühl — für dich und andere",
        "Konsequenz — Tag für Tag",
      ],
    },
  },
  /* 12 (Roadmap) — FIX: Wöchentlichen → Wöchentliche, Persönliche → persönliche */
  {
    num: 12, type: "process",
    kicker: "SAT MASTER ROADMAP",
    title: "6 Monate. 24 Wochen. Ein klarer Weg durch deine Transformation.",
    bullets: [
      { h: "Modul 1 · Wo 1–4", t: "Selbsterkenntnis & Standortbestimmung." },
      { h: "Modul 2 · Wo 5–8", t: "Muster, Prägungen & Glaubenssätze." },
      { h: "Modul 3 · Wo 9–12", t: "Beziehungen & Spiegelgesetze." },
      { h: "Modul 4 · Wo 13–16", t: "Berufung, Werte & Lebensvision." },
      { h: "Modul 5 · Wo 17–20", t: "Umsetzung & neue Identität." },
      { h: "Modul 6 · Wo 21–24", t: "Integration & Meisterschaft." },
    ],
    side: {
      title: "Das macht den Unterschied",
      items: [
        "24 Wochen klare Struktur",
        "Live Coaching & Q&A — Regelmäßige Live Calls für persönliche Begleitung",
        "Hochwertige Inhalte für jede Phase",
        "Wöchentliche Tools, Übungen und Aufgaben",
        "Community: gemeinsam wachsen",
        "Messbare Ergebnisse statt vager Versprechen",
      ],
    },
    mantra: "Am Ende von 24 Wochen bist du nicht mehr derselbe Mensch. Du bist die beste Version von dir.",
  },
  /* 13 (Scheitern) — FIX: "Währheit" → "Wahrheit" */
  {
    num: 13, type: "content",
    kicker: "WARUM BISHERIGE LÖSUNGEN OFT SCHEITERN",
    title: "Wer nach innen schaut, erwacht. Wer sich selbst erkennt, verändert sein Leben.",
    bullets: [
      { h: "Symptome statt Ursachen", t: "Pillen für Schmerzen, die aus deinem System sprechen." },
      { h: "Kurzfristige Erleichterung", t: "Motivation hält Wochen — Identität hält Jahrzehnte." },
      { h: "Wiederkehrende Muster", t: "Du wechselst das Außen, nicht das innere Programm." },
      { h: "Fehlende Integration", t: "Wissen ohne Verkörperung verändert nichts." },
      { h: "Keine Klarheit über das wahre Selbst", t: "Man trifft Entscheidungen aus alten Prägungen — nicht aus der eigenen Wahrheit." },
    ],
    mantra: "Verstehen. Integrieren. Transformieren. Das ist der Unterschied.",
    mantraSub: "SAT Master geht in die Tiefe. Wir arbeiten an der Ursache — nicht am Symptom.",
  },
  /* 14 — FIX: "Energie dahinter gezielt auf" geglättet */
  {
    num: 14, type: "content",
    kicker: "MODUL 2",
    title: "Muster, Prägungen & Glaubenssätze.",
    subtitle: "Verstehe dein inneres Programm — befreie dich von alten Mustern.",
    bullets: [
      { h: "Ursprung deiner Prägungen verstehen", t: "Wie Kindheit, Familie, Schule und Gesellschaft deine heutige Realität formen." },
      { h: "Begrenzende Glaubenssätze aufdecken", t: "Die unsichtbaren Überzeugungen erkennen, die dich klein halten." },
      { h: "Negative Muster durchbrechen", t: "Wiederkehrende emotionale und mentale Muster verstehen und transformieren." },
      { h: "Neuprogrammierung etablieren", t: "Neue, stärkende Glaubenssätze verankern und dein Unterbewusstsein neu ausrichten." },
      { h: "Selbstbild & Identität stärken", t: "Aus alten Rollen aussteigen und dein neues Selbstbild bewusst gestalten." },
    ],
    side: {
      title: "Dein Transformations-Prozess",
      items: [
        "Bewusst werden — erkenne deine Muster.",
        "Verstehen — warum entstanden sie, welchen Zweck hatten sie?",
        "Lösen — löse die emotionale Bindung gezielt auf — und mit ihr die Energie dahinter.",
        "Neu ausrichten — ersetze alte Glaubenssätze durch neue.",
        "Verankern — integriere bis es Normalität wird.",
      ],
    },
    mantra: "Du bist nicht deine Prägung. Du bist der Schöpfer deiner neuen Überzeugungen.",
  },
  /* 15 — FIX: "DEINEM PARTNER" → "ZU DEINEM PARTNER" (Parallelismus) */
  {
    num: 15, type: "content",
    kicker: "MODUL 3",
    title: "Beziehungen & Spiegelgesetze.",
    subtitle: "Durch bewusste Beziehungen entsteht wahre Transformation.",
    bullets: [
      { h: "Der Spiegel", t: "Andere zeigen dir, was in dir ungesehen ist." },
      { h: "Verbindung", t: "Heilung geschieht in verbindenden Beziehungen." },
      { h: "Lösen von Mustern", t: "Erkenne und durchbreche alte Beziehungsmuster." },
      { h: "Authentizität", t: "Wahre Nähe entsteht, wenn du du selbst bist." },
    ],
    side: {
      title: "Die 5 Beziehungs-Ebenen",
      items: ["Zu dir selbst", "Zu deinem Partner", "Zu deiner Familie", "Zu deinem Umfeld", "Zu deiner Berufung"],
    },
    mantra: "Heile deine Beziehung zu dir — und alles andere beginnt sich zu heilen.",
  },
  /* 16 */
  {
    num: 16, type: "content",
    kicker: "MODUL 4",
    title: "Berufung, Werte & Lebensvision.",
    subtitle: "Entdecke deine wahre Bestimmung und gestalte ein Leben mit Sinn und Wirkung.",
    bullets: [
      { h: "Wer bin ich wirklich?", t: "Lerne dich jenseits von Rollen, Prägungen und Erwartungen kennen." },
      { h: "Was ist meine Aufgabe?", t: "Entdecke deine einzigartige Lebensaufgabe." },
      { h: "Welche Werte tragen mich?", t: "Klare Werte geben Orientierung in allen Lebensbereichen." },
      { h: "Welche Talente habe ich?", t: "Erkenne und entfalte deine natürlichen Gaben." },
      { h: "Wofür möchte ich stehen?", t: "Finde heraus, wofür dein Herz brennt." },
      { h: "Welche Spur hinterlasse ich?", t: "Gestalte ein Vermächtnis, das bleibt." },
    ],
    mantra: "Deine Berufung ist nicht das, was du tust. Sie ist das, wofür du brennst und was die Welt durch dich braucht.",
  },
  /* 17 — FIX: "WIRD ZUR DEINEN" → "WIRD ZU DEINER" */
  {
    num: 17, type: "content",
    kicker: "MODUL 5",
    title: "Umsetzung & neue Identität.",
    subtitle: "Werde zur Person, die du beschlossen hast zu sein — jeden Tag.",
    bullets: [
      { h: "Klare Entscheidungen treffen", t: "Triff bewusste Entscheidungen, die dich in die Richtung deiner Vision führen." },
      { h: "Gewohnheiten & Routinen aufbauen", t: "Schaffe tägliche Routinen, die deine neue Identität stärken." },
      { h: "Verantwortung übernehmen", t: "Übernimm 100 % Verantwortung für dein Leben." },
      { h: "Integration & Verkörperung", t: "Integriere das Gelernte auf allen Ebenen — mental, emotional, körperlich, spirituell." },
      { h: "Deine neue Identität leben", t: "Du wirst nicht mehr von alten Mustern gesteuert." },
      { h: "Wirkung entfalten", t: "Teile deine Erfahrung, inspiriere andere." },
    ],
    mantra: "Deine Transformation wird zu deiner Identität.",
    mantraSub: "Du denkst anders. Du fühlst anders. Du handelst anders. Du bist anders.",
  },
  /* 18 — FIX: "Rückfallen" → "Rückfälle", "Neues leben" → "Neues Leben" */
  {
    num: 18, type: "content",
    kicker: "MODUL 6",
    title: "Integration & Umsetzung.",
    subtitle: "Dein neues Leben — Tag für Tag, Schritt für Schritt.",
    bullets: [
      { h: "Wissen in Handlung bringen", t: "Übersetze Erkenntnis in konkrete Schritte." },
      { h: "Tägliche Praxis", t: "Einfache, wirksame Routinen, die dich auf Kurs halten." },
      { h: "Fortschritt messen", t: "Reflektiere regelmäßig, feiere Erfolge, justiere bewusst nach." },
      { h: "Unterstützung & Community", t: "Wachse in einer inspirierenden Gemeinschaft." },
      { h: "Rückfälle & Integration", t: "Nutze Herausforderungen als Chance — entwickle Resilienz." },
      { h: "Deine neue Identität leben", t: "Du denkst, fühlst und handelst im Einklang mit deinem wahren Selbst." },
    ],
    mantra: "Konsistenz macht den Unterschied.",
    mantraSub: "Kleine Schritte. Jeden Tag. In die gleiche Richtung. Altes loslassen — Neues Leben.",
  },
  /* 19 — FIX: Possessiv-Bruch */
  {
    num: 19, type: "content",
    kicker: "MODUL 7",
    title: "Ressourcen & Energiequellen.",
    subtitle: "Stärke deinen Körper, Geist und Seele. Energie ist die Währung der Transformation.",
    bullets: [
      { h: "Körperliche Vitalität", t: "Ernährung, Bewegung, Schlaf und Regeneration." },
      { h: "Mentale Klarheit", t: "Fokussiere deinen Geist, reduziere Ablenkungen." },
      { h: "Emotionale Resilienz", t: "Lerne, Emotionen zu verstehen, zu regulieren und zu integrieren." },
      { h: "Spirituelle Verbindung", t: "Vertiefe deine Verbindung zu dir selbst und zu etwas Größerem." },
      { h: "Energie-Management", t: "Richte deine Energie bewusst aus." },
      { h: "Natur & Umgebung", t: "Nutze die Kraft der Natur und der richtigen Räume für dein Wachstum." },
    ],
    mantra: "Du kannst nicht geben, was du selbst nicht hast.",
  },
  /* 20 */
  {
    num: 20, type: "content",
    kicker: "MODUL 8",
    title: "Transformation & Integration.",
    subtitle: "Veränderung leben. Neue Realität erschaffen. Dein bestes Leben verkörpern.",
    bullets: [
      { h: "Alte Identität loslassen", t: "Löse dich von alten Mustern, Rollen und Geschichten." },
      { h: "Neue Identität verkörpern", t: "Werde zur Person, die du sein willst — in Denken, Fühlen, Handeln und Sein." },
      { h: "Gewohnheiten verankern", t: "Integriere neue Routinen, die deine Transformation stabilisieren." },
      { h: "Beziehungen transformieren", t: "Umgebe dich mit Menschen, die dich stärken." },
      { h: "Beitrag & Wirkung entfalten", t: "Teile deine Gaben mit der Welt." },
      { h: "Leben in Fülle & Freiheit", t: "Erlebe ein Leben in Sinn, Freude und Leichtigkeit." },
    ],
    mantra: "Du bist dein bestes Projekt.",
  },
  /* 21 — FIX: "in Einklang" → "im Einklang" */
  {
    num: 21, type: "content",
    kicker: "MODUL 9",
    title: "Lebensvision & Bestimmung.",
    subtitle: "Dein Leben hat eine Aufgabe. Entdecke sie. Lebe sie. Hinterlasse deine Spur.",
    bullets: [
      { h: "Deine Einzigartigkeit erkennen", t: "Verstehe, was dich einzigartig macht — deine Essenz ist dein Geschenk." },
      { h: "Deine Aufgabe finden", t: "Entdecke den Beitrag, den nur du in diese Welt bringen kannst." },
      { h: "Deine Werte leben", t: "Klare Werte geben deinem Leben Richtung." },
      { h: "Deine Talente entfalten", t: "Erkenne deine Talente und nutze sie im Einklang mit deinem Herzen und deiner Bestimmung." },
      { h: "Deine Spur hinterlassen", t: "Lege heute den Grundstein für ein Vermächtnis." },
      { h: "Wirken mit Herz & Sinn", t: "Verbinde Herz, Verstand und Seele." },
    ],
    mantra: "Deine Vision ist das Bild deiner Zukunft. Deine Bestimmung ist der Weg dorthin. Dein Handeln ist die Brücke.",
  },
  /* 22 — FIX: "Leben reagieren" → "Reaktiv leben", Komma entfernt */
  {
    num: 22, type: "comparison",
    kicker: "MODUL 10",
    title: "Vorher · Nachher.",
    subtitle: "Erkenne den Unterschied. Fühle die Veränderung. Gestalte dein neues Leben.",
    vorher: [
      { h: "Getrieben & überfordert", t: "Ständig im Außen, keine Klarheit." },
      { h: "Gefangen in Mustern", t: "Alte Prägungen bestimmen dein Leben." },
      { h: "Beziehungen belasten", t: "Missverständnisse, Konflikte und Enttäuschungen." },
      { h: "Kein Ziel & keine Richtung", t: "Du funktionierst, aber spürst keine Erfüllung." },
      { h: "Energieverlust", t: "Erschöpft, ausgebrannt und ohne Lebensfreude." },
      { h: "Reaktiv leben", t: "Du lässt dich von Umständen steuern." },
    ],
    nachher: [
      { h: "Klarheit & innere Ruhe", t: "Du weißt, wer du bist und was du willst." },
      { h: "Frei von alten Mustern", t: "Du triffst bewusste Entscheidungen und lebst authentisch." },
      { h: "Erfüllende Beziehungen", t: "Tiefe Verbindung, Vertrauen und gegenseitige Wertschätzung." },
      { h: "Zielgerichtet & inspiriert", t: "Dein Lebensweg ist klar und deine Vision treibt dich an." },
      { h: "Hohe Energie & Lebensfreude", t: "Du fühlst dich vital, kraftvoll und begeistert." },
      { h: "Leben gestalten", t: "Du übernimmst Verantwortung und erschaffst deine Realität." },
    ],
    mantra: "Du bist nicht mehr der Mensch, der du einmal warst. Aber du wirst der Mensch, der du immer sein solltest.",
  },
  /* 23 — Modul 11 umbenannt: "Gelebte Identität" (vorher Duplikat von M5) */
  {
    num: 23, type: "content",
    kicker: "MODUL 11",
    title: "Gelebte Identität.",
    subtitle: "Neue Entscheidungen. Neue Gewohnheiten. Neue Identität.",
    bullets: [
      { h: "Klare Entscheidungen treffen", t: "Entscheide dich jeden Tag bewusst für dein Ziel." },
      { h: "Konsequent handeln", t: "Kleine Schritte — jeden Tag. Konsistenz schlägt Motivation." },
      { h: "Neue Gewohnheiten verankern", t: "Ersetze alte Muster durch neue Routinen." },
      { h: "Neue Identität leben", t: "Handle, denke und fühle wie die Person, die du werden willst." },
      { h: "Rückschläge integrieren", t: "Nutze Herausforderungen als Teil des Weges." },
      { h: "Fortschritt messen & feiern", t: "Reflektiere, feiere Erfolge, bleibe in deiner Ausrichtung." },
    ],
    mantra: "Identität ist nicht das, was du denkst, sondern das, was du jeden Tag lebst.",
  },
  /* 24 — FIX: "Vererbung" → "Vermächtnis" */
  {
    num: 24, type: "process",
    kicker: "MODUL 12",
    title: "Dein Transformations-Roadmap.",
    subtitle: "Dein Weg. Dein Tempo. Deine Transformation.",
    bullets: [
      { h: "01 · Orientierung & Klarheit", t: "Standort bestimmen. Ziele definieren. Innere Klarheit gewinnen." },
      { h: "02 · Aufbruch & Reinigung", t: "Altes loslassen. Muster erkennen. Innere Blockaden lösen." },
      { h: "03 · Aufbau & Integration", t: "Neue Gewohnheiten verankern. Werte leben. Identität stärken." },
      { h: "04 · Entfaltung & Wirkung", t: "Deine Vision leben. Talente entfalten. Menschen inspirieren." },
      { h: "05 · Beitrag & Vermächtnis", t: "Einen bleibenden Beitrag leisten. Spuren hinterlassen." },
    ],
    mantra: "Es geht nicht darum, wohin der Weg führt, sondern wer du auf diesem Weg wirst.",
  },
  /* 25 */
  {
    num: 25, type: "content",
    kicker: "MODUL 13",
    title: "Konsistenz & Nachhaltigkeit.",
    subtitle: "Dranbleiben. Vertiefen. Wachsen. Deine Transformation leben.",
    bullets: [
      { h: "Tägliche Routinen verankern", t: "Kleine, bewusste Handlungen — jeden Tag." },
      { h: "Fokus & Energie schützen", t: "Setze klare Prioritäten. Lerne Nein zu sagen." },
      { h: "Reflexion & Lernen", t: "Überprüfe regelmäßig deinen Weg. Lerne, passe an und wachse weiter." },
      { h: "Unterstützung & Verbindung", t: "Umgebe dich mit Menschen, die dich stärken." },
      { h: "Leben voller Bedeutung", t: "Lebe im Einklang mit deinen Werten." },
    ],
    mantra: "Wahre Transformation ist ein Lebensstil. Nicht perfekt, aber echt. Nicht einmalig, sondern täglich.",
  },
  /* 26 — FIX: "Impact" → "Wirkung" */
  {
    num: 26, type: "content",
    kicker: "MODUL 14",
    title: "Integration & Meisterschaft.",
    subtitle: "Du bist bereit. Du bist gewachsen. Du bist der Wandel.",
    bullets: [
      { h: "Alles zusammenführen", t: "Verbinde Wissen, Erfahrung und Intuition." },
      { h: "Deine Einzigartigkeit leben", t: "Kein Vergleichen mehr. Kein Beweisen mehr." },
      { h: "Andere inspirieren", t: "Deine Präsenz berührt. Du wirst zum Leuchtturm." },
      { h: "Verantwortung übernehmen", t: "Für dich. Für dein Wirken. Für die Welt." },
      { h: "Dein Erbe gestalten", t: "Was du heute säst, wirkt in die Zukunft." },
      { h: "Meisterschaft leben", t: "Nicht das Ziel ist Meisterschaft — sondern das tägliche bewusste Sein." },
    ],
    side: {
      title: "Deine Wirkung — Dein Erbe",
      items: [
        "Du bringst Licht in die Welt",
        "Du erhebst andere durch dein Sein",
        "Du gestaltest Zukunft aktiv mit",
        "Du lebst Liebe, Freiheit & Wahrheit",
        "Du hinterlässt ein Erbe voller Sinn",
        "Du bist Transformation in Bewegung",
      ],
    },
    mantra: "Du bist die Transformation. Du bist der Wandel, auf den du gewartet hast.",
  },
  /* 27 */
  {
    num: 27, type: "content",
    kicker: "MODUL 15",
    title: "Vermächtnis & Wirkung.",
    subtitle: "Dein Leben. Dein Beitrag. Deine Spur in der Welt.",
    bullets: [
      { h: "Deine einzigartige Essenz", t: "Erkenne, was dich ausmacht — deine Werte, Gaben und Leidenschaften." },
      { h: "Dein Beitrag zählt", t: "Jede noch so kleine Handlung hat Wirkung." },
      { h: "Menschen inspirieren", t: "Sei ein Vorbild. Teile dein Wissen." },
      { h: "Nachhaltige Wirkung schaffen", t: "Denke langfristig. Baue etwas auf, das bleibt." },
      { h: "Dein Vermächtnis gestalten", t: "Was soll bleiben, wenn du gehst?" },
      { h: "Integration & Feier", t: "Feiere, was du geworden bist. Deine Transformation ist erst der Anfang." },
    ],
    mantra: "Dein Vermächtnis ist deine Liebe in Aktion.",
  },
  /* 28 — FIX: "Legacy" 3× → "Vermächtnis" */
  {
    num: 28, type: "content",
    kicker: "MODUL 16",
    title: "Verantwortung & Vermächtnis.",
    subtitle: "Deine Verantwortung. Dein Erbe. Deine Spuren bleiben.",
    bullets: [
      { h: "Deine Verantwortung annehmen", t: "Niemand sonst lebt dein Leben. Stehe zu deinen Entscheidungen — immer." },
      { h: "Vorbild & Einfluss sein", t: "Dein Verhalten prägt andere. Sei ein Vorbild." },
      { h: "Etwas Dauerhaftes schaffen", t: "Baue auf, was bleibt — Werte, Werke, Wissen." },
      { h: "Dienen & zurückgeben", t: "Nutze deine Gaben, um anderen zu helfen." },
      { h: "Deine Geschichte schreiben", t: "Jede Entscheidung formt deine Geschichte. Schreibe sie bewusst." },
      { h: "Ein Erbe, das bleibt", t: "Dein Vermächtnis ist, was in Herzen weiterlebt." },
    ],
    mantra: "Die beste Art, die Zukunft vorherzusagen, ist, sie aktiv zu gestalten — mit Verantwortung und Herz.",
  },
  /* 29 — FIX: "Bewussteein" → "Bewusstsein", "in Wandel" → "im Wandel" */
  {
    num: 29, type: "content",
    kicker: "MODUL 17",
    title: "Für wen ist der SAT Master geeignet?",
    subtitle: "Wenn du spürst: Es ist Zeit für echte Veränderung.",
    bullets: [
      { h: "Für Menschen mit tiefer Frage", t: "Du spürst, da ist mehr. Du willst verstehen, wer du wirklich bist." },
      { h: "Für Persönlichkeiten im Wandel", t: "Du stehst an einem Wendepunkt. Du bist bereit, alte Muster zu lösen." },
      { h: "Für Herzensführer & Visionäre", t: "Du willst nicht nur für dich wachsen, sondern etwas in der Welt bewegen." },
      { h: "Für Verantwortungsbewusste", t: "Du übernimmst Verantwortung — für dich, dein Leben, deinen Beitrag." },
      { h: "Für Lernende mit offenem Geist", t: "Du bist offen, neugierig und bereit, dich auf neue Perspektiven einzulassen." },
    ],
    mantra: "Dieser Weg ist kein Programm. Es ist eine Entscheidung — für ein Leben in Bewusstsein, Wirkung und Erfüllung.",
  },
  /* 30 — FIX: "VERPASSENES" → "VERPASSTES" */
  {
    num: 30, type: "comparison",
    kicker: "MODUL 18",
    title: "Für wen der SAT Master NICHT geeignet ist.",
    subtitle: "Dieser Weg ist nichts für jeden. Und das ist gut so.",
    vorher: [
      { h: "Menschen, die keine Verantwortung übernehmen wollen", t: "Du bist nicht bereit, dein Leben selbst in die Hand zu nehmen." },
      { h: "Menschen, die immer andere schuldig machen", t: "Wenn du in der Opferrolle bleibst, kommst du hier nicht weiter." },
      { h: "Menschen, die nur schnelle Lösungen suchen", t: "Dieser Weg bringt keine Abkürzungen. Echte Veränderung braucht Zeit." },
      { h: "Menschen, die nicht bereit sind, sich selbst zu reflektieren", t: "Selbstreflexion ist der Schlüssel." },
      { h: "Menschen, die keine Veränderung wollen", t: "Wenn du insgeheim möchtest, dass alles bleibt, wie es ist." },
      { h: "Menschen, die lieber jammern als handeln", t: "Klagen verändert nichts. Handeln verändert alles." },
    ],
    nachher: [
      { h: "Klarheit und Bewusstheit", t: "Du weißt, wo du stehst und wohin du willst." },
      { h: "Innerem Wachstum", t: "Tiefe Entwicklung — nicht Oberfläche." },
      { h: "Echtem Wandel", t: "Nicht Symptom-Bekämpfung, sondern Ursachen-Heilung." },
      { h: "Einem erfüllten Leben", t: "Sinn, Verbundenheit, Wirkung." },
      { h: "Lichtwegweisern", t: "Licht · Wachstum · Verantwortung · Transformation · Erfülltes Leben." },
      { h: "Einer ehrlichen Reise", t: "Weg vom verpassten Leben — hin zu deinem wahren Leben." },
    ],
    mantra: "Dieser Weg ist fordernd. Er bringt dich an deine Grenzen — und darüber hinaus. Aber nur wenn du wirklich bereit bist.",
  },
  /* 31 */
  {
    num: 31, type: "comparison",
    kicker: "MODUL 19",
    title: "Mögliche Ergebnisse deiner Transformation.",
    subtitle: "Dein neues Leben beginnt mit deiner Entscheidung.",
    vorher: [
      { h: "Oberflächliche Beziehungen", t: "Einsamkeit, Missverständnisse." },
      { h: "Erschöpfung", t: "Stress, Krankheit, Energielosigkeit." },
      { h: "Selbstzweifel", t: "Unsicherheit, negatives Selbstbild." },
      { h: "Ziellosigkeit", t: "Frust im Job, kein Sinn im Leben." },
      { h: "Finanzielle Sorgen", t: "Abhängigkeit, Mangeldenken." },
      { h: "Antriebslosigkeit", t: "Frust, keine Lebensfreude." },
    ],
    nachher: [
      { h: "Tiefe Beziehungen", t: "Liebe und Verbundenheit." },
      { h: "Gesund und voller Energie", t: "Kraft und Lebensfreude." },
      { h: "Selbstliebe", t: "Innere Stärke, Klarheit über deinen Wert." },
      { h: "Berufung leben", t: "Mit Leidenschaft und Sinn." },
      { h: "Finanzielle Freiheit", t: "Fülle und Unabhängigkeit." },
      { h: "Dankbarkeit & Lebensfreude", t: "Leichtigkeit, Glück." },
    ],
    mantra: "Du wirst nicht das gleiche Leben führen können, wenn du nicht bereit bist, ein anderer Mensch zu werden.",
  },
  /* 32 — FIX: "wieder gefunden" → "wiedergefunden" */
  {
    num: 32, type: "cases",
    kicker: "MODUL 20",
    title: "Fallbeispiele & Transformationen.",
    subtitle: "Echte Menschen. Echte Prozesse. Echte Ergebnisse.",
    cases: [
      {
        name: "MARC", age: "44 Jahre · Unternehmer",
        before: ["Ständige Überforderung", "Getrieben und gestresst", "Keine Zeit für Familie", "Finanzielle Unsicherheit", "Innere Leere und Sinnlosigkeit"],
        process: ["Verantwortung übernommen", "Innere Klarheit gewonnen", "Alte Muster aufgelöst", "Finanzielle Strategie entwickelt", "Beziehung zu Familie geheilt"],
        after: ["Freiheit und Zeit für das Wesentliche", "Erfolgreiches, erfülltes Business", "Tiefe Verbindung zur Familie", "Finanzielle Stabilität und Wachstum", "Lebensfreude und innere Erfüllung"],
        quote: "Ich habe mein Leben zurückerobert.",
      },
      {
        name: "SANDRA", age: "38 Jahre · Selbstständig",
        before: ["Geringes Selbstwertgefühl", "Ängste und Selbstzweifel", "Toxische Beziehung", "Erschöpft und ausgebrannt", "Kein Vertrauen in sich selbst"],
        process: ["Selbstwert aufgebaut", "Heilung alter Verletzungen", "Klare Grenzen gesetzt", "Gesundes Mindset entwickelt", "Neue Vision für ihr Leben erschaffen"],
        after: ["Starkes Selbstwertgefühl", "Frei von toxischen Mustern", "Gesunde, liebevolle Beziehung", "Energiegeladen und erfüllt", "Lebt ihre Berufung mit Freude"],
        quote: "Ich habe mich selbst wiedergefunden.",
      },
      {
        name: "THOMAS", age: "52 Jahre · Angestellter",
        before: ["Innerer Konflikt und Zweifel", "Unzufriedenheit im Job", "Gesundheit am Limit", "Keine klare Lebensrichtung", "Gefühl, nur zu funktionieren"],
        process: ["Innere Klarheit und Ausrichtung", "Gesunde Routinen etabliert", "Körper und Geist gestärkt", "Mut zur Veränderung entwickelt", "Neue Berufung gefunden"],
        after: ["Klarheit über seinen Lebensweg", "Neuer Job mit Sinn und Wirkung", "Gesund, fit und voller Energie", "Finanzielle Sicherheit", "Lebt mit Leidenschaft und Bedeutung"],
        quote: "Ich lebe heute ein Leben mit Bedeutung.",
      },
    ],
    mantra: "Jeder Mensch hat das Potenzial, sein Leben zu verändern. Die Entscheidung liegt bei dir.",
  },
  /* 33 */
  {
    num: 33, type: "content",
    kicker: "MODUL 21",
    title: "Was du im SAT Master erhältst.",
    subtitle: "Alles, was du für deine Transformation brauchst. Struktur. Tiefe. Begleitung.",
    bullets: [
      { h: "24-Wochen Transformations-Programm", t: "Ein klar strukturierter Weg in 6 Modulen." },
      { h: "Wöchentliche Live Calls", t: "Live Calls mit Nenad und dem Team." },
      { h: "Umfassendes Workbook", t: "Dein persönlicher Begleiter mit Übungen, Reflexionen und Tools." },
      { h: "Private Community", t: "Gleichgesinnte. Austausch. Unterstützung." },
      { h: "Aufzeichnungen & Mediathek", t: "Zugriff auf alle Aufzeichnungen, Trainings und Bonus-Content — jederzeit." },
      { h: "Persönliche Begleitung", t: "Individuelle Unterstützung, Klarheit und Feedback, wenn du es brauchst." },
      { h: "Tools & Methoden", t: "Bewährte Transformations-Methoden, Frameworks und Tools." },
    ],
    mantra: "Du bekommst nicht nur Information. Du bekommst Transformation.",
    mantraSub: "Wissen + Umsetzung + Begleitung = Ergebnisse.",
  },
  /* 34 — FIX: "BERUFUNG leben" → "BERUFUNG entfaltet sich" */
  {
    num: 34, type: "pricing",
    kicker: "MODUL 22",
    title: "Deine Investition.",
    subtitle: "Keine Kosten. Eine Investition in dein neues Leben.",
    bullets: [
      { h: "Das ist keine Ausgabe", t: "Das ist eine Entscheidung für dich selbst. Für dein Wachstum, deine Freiheit und deine Zukunft." },
      { h: "Was du investierst", t: "Deine Zeit und deinen Fokus. Dein Geld. Deine Bereitschaft, dich wirklich zu verändern." },
      { h: "Was du zurückbekommst", t: "Klarheit. Richtung. Tiefe Beziehungen. Berufung. Lebensfreude, die bleibt." },
      { h: "Der Wert deiner Transformation", t: "Ein Jahr deines Lebens kann alles verändern." },
    ],
    vorher: [
      { h: "Weiter im alten Muster feststecken", t: "" },
      { h: "Frust, Stress und Unzufriedenheit", t: "" },
      { h: "Keine Veränderung und Stillstand", t: "" },
      { h: "Opfer bleiben und Ausreden suchen", t: "" },
      { h: "Zeit verlieren, die du nie zurückbekommst", t: "" },
    ],
    nachher: [
      { h: "Transformation und persönliches Wachstum", t: "" },
      { h: "Ein Leben nach deinen Werten", t: "" },
      { h: "Freiheit, Klarheit und echte Erfüllung", t: "" },
      { h: "Verantwortung übernehmen und wachsen", t: "" },
      { h: "Ein Vermächtnis hinterlassen", t: "" },
    ],
    mantra: "Du investierst heute in dich — und erntest ein Leben lang.",
    mantraSub: "Investiere nicht in Dinge. Investiere in dich.",
  },
  /* 35 */
  {
    num: 35, type: "funnel",
    kicker: "MODUL 23",
    title: "Der nächste Schritt.",
    subtitle: "Deine Entscheidung. Dein Gespräch. Dein Start. Deine Transformation.",
    bullets: [
      { h: "01 · Bewerbung ausfüllen", t: "Fülle das Bewerbungsformular auf unserer Website aus. Nimm dir Zeit." },
      { h: "02 · Kennenlerngespräch", t: "Wir lernen uns in einem persönlichen Gespräch kennen." },
      { h: "03 · Entscheidung", t: "Wenn es für beide Seiten stimmig ist, sicherst du dir deinen Platz." },
      { h: "04 · Vorbereitung", t: "Du erhältst alle Informationen, um dich optimal auf deinen Start vorzubereiten." },
      { h: "05 · Dein Start", t: "Deine Transformation beginnt. Willkommen in deiner neuen Realität!" },
    ],
    mantra: "Dein neues Leben wartet.",
    mantraSub: "Der erste Schritt liegt bei dir. Wir sind bereit, dich zu begleiten. Bist du es auch?",
  },
  /* 36 — FIX: "Love is Transformation" → "Liebe ist Transformation", "Love starts with you" → "Liebe beginnt bei dir" */
  {
    num: 36, type: "content",
    kicker: "MODUL 24",
    title: "Liebe ist Transformation.",
    subtitle: "Dein neues Leben. Deine neue Realität. Deine Freiheit.",
    bullets: [
      { h: "Liebe beginnt bei dir", t: "Wahre Transformation beginnt mit Liebe. Liebe zu dir selbst. Alles andere ist nur Konsequenz." },
      { h: "Du bist der Schöpfer", t: "Du bist nicht Opfer deiner Umstände. Du bist der Schöpfer deiner Realität." },
      { h: "Transformation ist möglich", t: "Egal, wo du heute stehst. Egal, was gewesen ist. Deine Zukunft ist ungeschrieben." },
      { h: "Dein Potenzial ist grenzenlos", t: "In dir steckt mehr, als du je gedacht hast." },
      { h: "Gemeinsam erreichen wir Großes", t: "Du musst diesen Weg nicht allein gehen. Wir sind an deiner Seite." },
    ],
    mantra: "Du bist bereit. Du bist würdig. Du bist Liebe.",
    mantraSub: "Liebe ist die stärkste Kraft im Universum. Sie verwandelt. Sie heilt. Sie erschafft.",
  },
  /* 37 */
  {
    num: 37, type: "finale",
    kicker: "MODUL 25",
    title: "Deine Transformation beginnt jetzt.",
    subtitle: "Der Moment ist jetzt. Die Entscheidung ist deine. Das Ergebnis ist dein neues Leben.",
    bullets: [
      { h: "Jetzt ist der perfekte Zeitpunkt", t: "Es wird nie einen \u201eperfekten\u201c Zeitpunkt geben. Aber immer einen richtigen: JETZT." },
      { h: "Keine Ausreden mehr", t: "Die meisten Menschen warten auf Motivation. Die Erfolgreichen handeln — und finden Motivation im Tun." },
      { h: "Kleine Entscheidungen, große Veränderung", t: "Dein Leben verändert sich nicht über Nacht. Aber jede Entscheidung bringt dich näher." },
      { h: "Dein Engagement = Dein Ergebnis", t: "Je mehr du dich einbringst, desto mehr bekommst du. 100 % Einsatz — 100 % Transformation." },
      { h: "Du bist nicht allein", t: "Wir gehen diesen Weg gemeinsam. Mit Team, Community und einem Mentor, der an dich glaubt." },
    ],
    formula: ["Klarheit", "Verantwortung", "Handlung", "Ausdauer", "= Transformation"],
    mantra: "Ein Jahr von jetzt an wirst du dir wünschen, heute angefangen zu haben. Fang jetzt an!",
    mantraSub: "Sage Ja zu dir. Sage Ja zu deinem neuen Leben.",
  },
];

export default slides;
